export class AuthRideError extends Error {}
